import { Drag } from "compotes";

document.addEventListener("DOMContentLoaded", (event) => {
  addScrollable();
});

function addScrollable() {
  Array.from(document.getElementsByClassName("is-scrollable")).forEach(
    (el) => new Drag(el)
  );
}
